import { Edit as EditIcon } from "@mui/icons-material";
import { PlaylistAdd as PlaylistAddIcon } from "@mui/icons-material";
import type { MenuOptionType } from "../../../../../controls/contextMenu/models/MenuOptionType";
import type { CatalogBin } from "../../../models/CatalogBin";

type Props = {
  setBin: (bin: CatalogBin) => void;
  setShowModal: (show: "new" | "edit" | "delete" | "") => void;
  handleNewBin: () => void;
};
export const useBinsOptionsFunctions = ({
  setBin,
  setShowModal,
  handleNewBin,
}: Props) => {
  const getMenuOptions = (data: CatalogBin) => {
    let options: MenuOptionType[] = [
      {
        name: "New Bin",
        key: "new_bin",
        onClick: () => {
          handleNewBin();
        },
        icon: <PlaylistAddIcon />,
      },
    ];
    if (data) {
      options = options.concat([
        {
          name: "Edit Bin",
          key: "edit_bin",
          onClick: () => {
            setBin(data);
            setShowModal("edit");
          },
          icon: <EditIcon />,
        },
      ]);
    }
    return options;
  };
  return {
    getMenuOptions,
  };
};
